import { render } from "./SVGShield.vue?vue&type=template&id=2cfb28a2"
import script from "./SVGShield.vue?vue&type=script&lang=js"
export * from "./SVGShield.vue?vue&type=script&lang=js"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__